import React, {useState, useEffect} from "react";
import { SpaceBetween, Button, Container, Header, ButtonDropdown, Modal, Box, Table, Input } from "@cloudscape-design/components";
import { useAuth } from "../Auth";
import AccountAdmin from './AccountAdmin'
import { useApi } from "../Api";

export default function Account(){
  const path = 'Account/';
  const auth = useAuth();
  const Api = useApi();
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(true)
  const [delToken, setDelToken] = useState(null);
  const [name, setName] = useState(null);
  const [token, setToken] = useState(null);

  console.log(data)
  useEffect(() => {
    try{
      
      let rendered = true;
      Api.get( path, false ).then(object => {
        if (rendered) {
          setData(object);
          setDataLoading(false);
        }
      });
      return () => {
        rendered = false;
      };
    }
    catch{
      setData(null);
      setDataLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = ()=>{
    try{
      if(!dataLoading){
        setDataLoading(true)
        Api.get( path, true ).then(object => {
            setData(object);
            setDataLoading(false);
        })
      }
    }
    catch{}
  }

  const delT = async(tokenname)=>{
    try{

      await Api.delete( path + tokenname + '/', {tokenname} )
    }  
    catch{} 
    refresh();
  }

  const addToken = async(tokenName, token)=>{
    await Api.post( path + tokenName + '/', {token} )
    refresh();
  }

  const columnDefinitions = [
      { id: "Name", header: "Name", cell: item => item },
      {    
          id: 'actions',
          header: 'Actions',
          minWidth: 100,
          cell: item => (
            <ButtonDropdown
              items={[
                {
                  id: "delete",
                  text: "Delete",
                  iconName: "remove"
                }
              ]}
              variant="inline-icon"
              ariaLabel={`${item.Email} actions`}
              expandToViewport={true}
              onItemClick={({ detail }) => {
                  console.log(detail)
                 if (detail.id === "delete") {
                      setDelToken(item)
                  }
              }}
            />
          )
        }
    ];

    return(
      <SpaceBetween size="l">
              <Container
            header={<Header variant="h2">Account</Header>}
        >
          <SpaceBetween size="m">
            <SpaceBetween size="l">
              { auth.userData&&auth.userData.profile?
              <>
                Eamil: {auth.userData.profile.email}
                <br/>
                Admin: {auth.admin? 'True':'False'}
              </>
              :null}
            </SpaceBetween>
              <Button variant="primary" onClick={() => {auth.signOut()}}>
                Sign out
            </Button>
          </SpaceBetween>
        </Container>
        <Modal
          visible={delToken}
          onDismiss={()=>{setDelToken(null)}}
          header='Delete Token'
          closeAriaLabel="Close dialog"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={()=>setDelToken(null)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={()=>{delT(delToken);setDelToken(null)}}>
                  Delete
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
            Permanently delete token: {delToken?delToken:null}
        </Modal>

        <Modal
          visible={token!==null}
          onDismiss={()=>{ setName(null);setToken(null)}}
          header='Add Token'
          closeAriaLabel="Close dialog"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={()=>{ setName(null);setToken(null)}}>
                  Cancel
                </Button>
                <Button variant="primary" disabled={token===null} onClick={()=>{addToken(name, token); setName(null);setToken(null);}}>
                  Add
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <SpaceBetween direction="horizontal" size="m" alignItems="center">  
            <Input 
              type="name"
              value={name}
              onChange={({ detail }) => setName(detail.value)}
              placeholder=""
            />
            <Input 
              type="token"
              value={token}
              disabled={true}
            />
          </SpaceBetween>
        </Modal>
        <Table
            columnDefinitions={columnDefinitions}
            loading={dataLoading}
            loadingText="Loading Tokens"
            items={!dataLoading&&data?data.tokens:[]}
            header={
                <Header
                    actions={
                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                      <Button
                        iconName="refresh"
                        ariaLabel="Refresh"
                        loadingText="Refreshing Accounts table"
                        loading={dataLoading}
                        onClick={refresh}
                      />
                      <Button disabled={dataLoading} onClick={()=>setToken(crypto.randomUUID())}>Add</Button>
                    </SpaceBetween>
                    }
                >
                    {`Personal Tokens: ${!dataLoading&&data&&data.tokens?data.tokens.length:''}`}
                </Header>
            }
        />
        {auth.admin?
          <AccountAdmin/>
        :null}
      </SpaceBetween>

        
    )
}